import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import {
  Screen1,
  TargetAudience,
  AboutWorkshop,
  Lessons,
  Program,
  Speaker,
  Reviews,
  Registration,
  Advance
} from "../../../components/LandingTemplates/lyuboy_inostrannyi_za_mesyac";

const TITLE = 'Любой иностранный за месяц';
const DESCRIPTION = 'С нуля до разговора на бытовые темы с помощью методики преподавателя 4-х иностранных языков';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'89053cc820841629bd12eed593eb1b2c440fb15d'} id={'889093'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 />
      <TargetAudience />
      <AboutWorkshop />
      <Lessons />
      <Program />
      <Speaker/>
      <Reviews />
      <Registration widget={widget}/>
      <Advance/>
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
